var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('go-top',{staticClass:"tap-top top-cls",attrs:{"size":50,"bg-color":"#114734"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }